"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALL_STEP = exports.BILLS_STEP = exports.INCOME_STEP = void 0;
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const compose_1 = __importDefault(require("utils/compose"));
const immutable_1 = require("immutable");
const accounts_1 = require("companion-app-components/flux/accounts");
const categories_1 = require("companion-app-components/flux/categories");
const scheduledTransactionsUtils_1 = require("companion-app-components/flux/scheduled-transactions/scheduledTransactionsUtils");
const mui_1 = require("tss-react/mui");
const Grid_1 = __importDefault(require("@mui/material/Grid"));
const Avatar_1 = __importDefault(require("@mui/material/Avatar"));
const Table_1 = __importDefault(require("@mui/material/Table"));
const TableBody_1 = __importDefault(require("@mui/material/TableBody"));
const TableCell_1 = __importDefault(require("@mui/material/TableCell"));
const TableRow_1 = __importDefault(require("@mui/material/TableRow"));
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const Collapse_1 = __importDefault(require("@mui/material/Collapse"));
const Edit_1 = __importDefault(require("@mui/icons-material/Edit"));
const Delete_1 = __importDefault(require("@mui/icons-material/Delete"));
const CircularProgress_1 = __importDefault(require("@mui/material/CircularProgress"));
const Add_1 = __importDefault(require("@mui/icons-material/Add"));
const CheckCircle_1 = __importDefault(require("@mui/icons-material/CheckCircle"));
const QButton_1 = __importDefault(require("components/QButton"));
const QTip_1 = __importDefault(require("components/QuickenControls/QTip"));
const AmountField_1 = __importStar(require("components/QuickenControls/AmountField"));
const scheduledTransactionsUtils_2 = require("data/scheduledTransactions/scheduledTransactionsUtils");
const styles_1 = require("components/Dialogs/WfBillScout/styles");
const safebox_svg_1 = __importDefault(require("assets/zero-state-images/safebox.svg"));
const ZeroStateView_1 = __importDefault(require("components/ZeroStateView"));
const DialogHoc_1 = __importStar(require("components/DialogHoc"));
exports.INCOME_STEP = 'INCOME';
exports.BILLS_STEP = 'EXPENSE';
exports.ALL_STEP = 'ALL';
const actions = {
    [`${exports.BILLS_STEP}`]: 'Missing any other bills? find them from:',
    [`${exports.INCOME_STEP}`]: 'Missing any other income?',
    [`${exports.ALL_STEP}`]: 'Missing any other reminder?',
};
const useStyles = (0, mui_1.makeStyles)()(styles_1.ScheduleTransactionSelectorStyles);
const CellTitle = ({ id, title, parentClasses }) => (<QTip_1.default title={title} wrapOnly>
    <span id={id} className={parentClasses.cellTitle}>{title}</span>
  </QTip_1.default>);
const CellCaption = ({ id, caption, parentClasses }) => (<span id={id} className={parentClasses.cellCaption}>{caption}</span>);
const ScheduleTransactionSelector = ({ scheduledTransactions, allUpcomingTxns, onGoBack, setDialog, deleteScheduleTransaction, setEditScheduledTransaction, createEmptyScheduleTransaction, selected, setSelectedItems, openTransactionSelector, showFindingRecurring, type, reviewCurrentStep, hideAddManually, baseId, }) => {
    const categoriesById = (0, react_redux_1.useSelector)(categories_1.categoriesSelectors.getCategoriesById);
    const accountsById = (0, react_redux_1.useSelector)(accounts_1.accountsSelectors.getAccountsById);
    const { classes } = useStyles();
    const getSelectedItems = (0, react_1.useCallback)(() => selected || (0, immutable_1.List)(), [selected]);
    (0, react_1.useEffect)(() => {
        const setInitialSelection = () => {
            const newSelectedList = getSelectedItems().toSet().toList();
            setSelectedItems(type, newSelectedList);
        };
        setInitialSelection();
    }, [scheduledTransactions, getSelectedItems, setSelectedItems, type]);
    const checkItemSelected = (id) => {
        const selectedItems = getSelectedItems();
        return selectedItems.findIndex((x) => x === id) >= 0;
    };
    const toggleTransactionSelection = (txnType, id) => () => {
        const isSelected = checkItemSelected(id);
        let selectedItems = getSelectedItems();
        if (isSelected) {
            selectedItems = selectedItems.filterNot((x) => x === id);
        }
        else {
            selectedItems = selectedItems.push(id);
        }
        setSelectedItems(txnType, selectedItems);
    };
    const handleDelete = (scheduledTransaction) => () => {
        setDialog('Bills and Income', 'Do you want to delete this schedule transaction?', (dialog) => {
            if (['YES', DialogHoc_1.dialogActions.ENTER].includes(dialog.action)) {
                deleteScheduleTransaction(scheduledTransaction);
            }
        }, ['CANCEL', 'YES']);
    };
    const renderRow = (scheduledTransaction, key, reviewCurrStep) => {
        const selectedRow = checkItemSelected(scheduledTransaction.id);
        const upTxn = allUpcomingTxns.get(scheduledTransaction && scheduledTransaction.id);
        const schTxn = (0, scheduledTransactionsUtils_2.userFriendlyTxnNames)(scheduledTransaction, categoriesById, accountsById, (upTxn && upTxn.first()));
        const baseID = `scheduled-txn-${key}`;
        return (<TableRow_1.default key={scheduledTransaction.clientId || scheduledTransaction.id} id={baseID} hover className={classes.standardRow}>
        <TableCell_1.default className={classes.tableCellAvatar} classes={{ root: classes.tableCellRoot }}>
          <div className={classes.tableCellAvatarContent}>
            <Avatar_1.default className={classes.avatar}>
              {((scheduledTransaction.transaction || {}).payee || '')[0]}
            </Avatar_1.default>
          </div>
        </TableCell_1.default>

        <TableCell_1.default className={classes.tableCell} classes={{ root: classes.tableCellRoot }}>
          <div className={classes.tableCellPayeeContent}>
            <CellTitle id={`${baseID}-name`} title={schTxn.payeeName} parentClasses={classes}/>
            <CellCaption id={`${baseID}-type`} caption={scheduledTransactionsUtils_1.STTypeNamesEnum[schTxn.type]} parentClasses={classes}/>
          </div>
        </TableCell_1.default>

        <TableCell_1.default className={classes.tableCell} classes={{ root: classes.tableCellRoot }}>
          <div className={classes.tableCellAmountContent}>
            <AmountField_1.default showSign={AmountField_1.ShowSignEnum.NEGATIVE_ONLY} showColor={AmountField_1.ShowColorEnum.POSITIVE_ONLY} value={schTxn.amount} className={classes.cellTitle} id={`${baseID}-amount`}/>
            <CellCaption id={`${baseID}-next-instance-date`} caption={schTxn.nextDateFormatted} parentClasses={classes}/>
          </div>
        </TableCell_1.default>

        <TableCell_1.default className={classes.tableCell} classes={{ root: classes.tableCellRoot }}>
          <div className={classes.tableCellAccountContent}>
            <CellTitle id={`${baseID}-source-account`} title={schTxn.accountName} parentClasses={classes}/>
            <CellCaption id={`${baseID}-frequency`} caption={schTxn.frequency} parentClasses={classes}/>
          </div>
        </TableCell_1.default>

        <TableCell_1.default className={classes.tableCellActions} classes={{ root: classes.tableCellRoot }}>
          <div className={classes.tableCellActionsContent}>
            <IconButton_1.default onClick={() => { setEditScheduledTransaction(scheduledTransaction); }} size="large">
              <Edit_1.default />
            </IconButton_1.default>
            {reviewCurrStep && (<IconButton_1.default onClick={handleDelete(scheduledTransaction)} size="large">
                <Delete_1.default />
              </IconButton_1.default>)}
            {!reviewCurrStep && !scheduledTransaction.isUserVerified && (<IconButton_1.default onClick={toggleTransactionSelection(type, scheduledTransaction.id)} aria-label="select" size="large">
                {selectedRow ? (<CheckCircle_1.default className={classes.selectedIcon}/>) : (<Add_1.default className={classes.selectIcon}/>)}
              </IconButton_1.default>)}
          </div>
        </TableCell_1.default>
      </TableRow_1.default>);
    };
    const renderAddMissing = (actionType, reviewCurrStep) => {
        const actionTitle = actions[actionType];
        const buttons = [
            {
                id: baseId('action-back-button'),
                onClick: onGoBack,
                text: 'Suggestions',
                show: true,
            },
            {
                id: baseId('find-transactions-button'),
                onClick: openTransactionSelector,
                text: 'Transactions',
                show: true,
            },
            {
                id: baseId('add-manual-button'),
                onClick: createEmptyScheduleTransaction,
                text: 'Add Manually',
                show: !hideAddManually,
            },
        ].filter((x) => x.show);
        return (<Collapse_1.default in={reviewCurrStep} classes={{ root: classes.collapseArea, wrapper: classes.collapseAreaWrapper }}>
        <Grid_1.default container className={classes.bottomActionsTitleContainer}>
          <Grid_1.default item className={classes.missingTypeTitleTop}>{actionTitle}</Grid_1.default>
          <Grid_1.default item className={classes.bottomActionsRoot}>
            {buttons && buttons.map((button, index) => (<react_1.default.Fragment key={button.id}>
                {buttons.length === index + 1 && (<span className={classes.missingTypeTitleTop}>or</span>)}
                <QButton_1.default className={classes.wideButton} id={button.id} variant="outlined" onClick={button.onClick}>{button.text}
                </QButton_1.default>
              </react_1.default.Fragment>))}
          </Grid_1.default>
        </Grid_1.default>
      </Collapse_1.default>);
    };
    const renderZeroState = (reviewCurrStep) => !showFindingRecurring ? (<ZeroStateView_1.default icon={safebox_svg_1.default} primary={!reviewCurrStep ? 'We couldn\'t find any suggestion' : 'You don\'t have any transactions to review'} classes={{ root: classes.zeroRoot }}/>) : (<div className={classes.waiterRoot}>
      <p className={classes.waiterTitle}>Hang Tight!</p>
      <p className={classes.waiterText}>We are finding your recurring bills and income.</p>
      <div className={classes.waiterCircularRoot}>
        <CircularProgress_1.default size={40} style={{ margin: 10 }}/>
        <p className={classes.waiterText}>This should only take a few moments.</p>
      </div>
    </div>);
    const currentSchTxn = scheduledTransactions.filter((x) => reviewCurrentStep ? x.isUserVerified : !x.isUserVerified);
    return (<Grid_1.default container className={classes.scheduleTxnSelectorRoot}>
      <Grid_1.default item className={classes.scheduleTxnSelectorWrapper}>
        {!currentSchTxn.size ?
            renderZeroState(reviewCurrentStep) :
            <Table_1.default>
            <TableBody_1.default>
              {currentSchTxn && currentSchTxn.size > 0 &&
                    currentSchTxn.valueSeq().map((txn, key) => renderRow(txn, key, reviewCurrentStep))}
            </TableBody_1.default>
          </Table_1.default>}
      </Grid_1.default>
      <Grid_1.default item>
        {renderAddMissing(type, reviewCurrentStep)}
      </Grid_1.default>
    </Grid_1.default>);
};
exports.default = (0, compose_1.default)((0, DialogHoc_1.default)())(ScheduleTransactionSelector);
